import { render, staticRenderFns } from "./CtaText.vue?vue&type=template&id=b1c16280"
import script from "./CtaText.vue?vue&type=script&lang=js"
export * from "./CtaText.vue?vue&type=script&lang=js"
import style0 from "./CtaText.vue?vue&type=style&index=0&id=b1c16280&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports